import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { pickingListColumns } from "@patronix/domain/list";
import { PickingPage } from "@/features/journals/PickingPage";
import { listView, viewSearch, type ViewSearch } from "@/lib/listView";

interface Search extends ViewSearch {
  so?: string | undefined;
}

export const Route = createFileRoute("/_app/sales/picking")({
  validateSearch: (raw: Record<string, unknown>): Search => ({
    ...(typeof raw.so === "string" && raw.so ? { so: raw.so } : {}),
    ...viewSearch(pickingListColumns, raw),
  }),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<Search>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return (
    <PickingPage selected={search.so} onSelect={(so) => setSearch({ so })} view={listView(pickingListColumns, search, setSearch)} />
  );
}
